<template>
  <form @submit.prevent="submitForm">
    <div v-if="LoggedIn">
      <section>
        <h2>
          投稿するサービスの「名称」「説明」を入力し，カテゴリーを選択してください．
        </h2>
      </section>

      <section>
        <div>
          <label for="uploadtitle">タイトル</label><div class="check">*</div>
          <input id="uploadtitle" type="text" v-model="uploadTitle" />
          <label for="uploadexplain">説明</label><div class="check">*</div><br />
          <textarea id="uploadexplain" row="5" cols="40" v-model="uploadExplain" style="height: 5lh;"></textarea><br />
          <label for="uploadmanager">管理者名</label><div class="check">*</div>
          <input id="uploadmanager" type="text" v-model="uploadmanager" /><br />
          <h3>カテゴリー<div class="check">*</div></h3>
          <label for="uploadcategory_system" class="my-radio">
            <input
              type="radio"
              id="uploadcategory_system"
              v-model="uploadCategory"
              value="システム"
            /><span class="radio-mark"></span> システム</label
          >

          <label for="uploadcategory_data" class="my-radio">
            <input
              type="radio"
              id="uploadcategory_data"
              v-model="uploadCategory"
              value="オープンデータ"
            /><span class="radio-mark"></span>オープンデータ</label
          >
          <!--ここから新規-->
          <label for="uploadcategory_api" class="my-radio">
            <input
              type="radio"
              id="uploadcategory_api"
              v-model="uploadCategory"
              value="API"
            /><span class="radio-mark"></span>API</label
          >
          <!--ここまで新規-->
        </div>
        入力方法について不明点がある場合は，
        <router-link to="/uploadtutorial">アップロードチュートリアル</router-link>
        をご覧ください。
      </section>

      <!-- システムの入力項目 -->
      <div v-if="uploadCategory === 'システム'">
        <section>
          <h2>URLを入力してください。</h2>
        </section>
        <section>
          <label for="uploadsystemURL"> システムURL </label><div class="check">*</div>
          <input id="uploadsystemURL" type="text" v-model="uploadSystemURL" />
          <label for="uploadmanualURL"
            >システムに関する資料(PDF)をアップロードすることができます</label
          >
          <input
            id="uploadmanualURL"
            type="file"
            accept="application/pdf"
            @change="handleFileUpload"
          />
          <span v-if="fileError" style="color: red">{{ fileError }}</span
          ><br />
          <button type="submit">Upload to DB</button>
          <h3>
            Upload Result :<br />
            {{ uploadResult }}
          </h3>
        </section>
      </div>

      <!-- オープンデータの入力項目 -->
      <div v-if="uploadCategory === 'オープンデータ'">
        <section>
          <h2>該当する項目を選択し，投稿するファイルを選択してください。</h2>
        </section>

        <section>
          <h4>ジャンル<div class="check">*</div></h4>
          <label for="uploadfilegenre_bridge" class="my-radio"
            ><input
              type="radio"
              id="uploadfilegenre_bridge"
              v-model="uploadFileGenre"
              value="橋梁"
            /><span class="radio-mark"></span>橋梁</label
          >

          <label for="uploadfilegenre_tunnel" class="my-radio"
            ><input
              type="radio"
              id="uploadfilegenre_tunnel"
              v-model="uploadFileGenre"
              value="トンネル"
            /><span class="radio-mark"></span> トンネル</label
          >
          <label for="uploadfilegenre_other" class="my-radio"
            ><input
              type="radio"
              id="uploadfilegenre_other"
              v-model="uploadFileGenre"
              value="その他"
            /><span class="radio-mark"></span> その他
          </label>
          <br />

          <label for="uploadlicense">ライセンス</label><div class="check">*</div><br />
          <select id="uploadlicense" type="text" v-model="uploadlicense">
            <option value="CC0">CC0</option>
            <option value="CC BY">CC BY</option>
            <option value="CC BY-NC">CC BY-NC</option>
            <option value="ODbL">ODbL</option>
            <option value="その他">その他</option>
          </select>
          <br />
          <label for="uploaddescription">データの説明</label><div class="check">*</div><br />
          <textarea id="uploaddescription" row="5" cols="40" v-model="uploaddescription" style="height: 5lh;"></textarea><br />

          <label for="uploadfile">Upload File</label><div class="check">*</div>
          <input id="uploadfile" @change="loadLog" type="file" />
          <button type="submit">Upload to DB</button>
          <h3>
            Upload Result :<br />
            {{ uploadResult }}
          </h3>
        </section>
      </div>
      <!-- APIの入力項目 -->
      <div v-if="uploadCategory === 'API'">
        <section>
          <h2>APIの情報を入力してください。</h2>
        </section>
        <section>
          <label for="uploadapiURL"> base URL </label><div class="check">*</div>
          <input id="uploadapiURL" type="text" v-model="uploadAPIURL" />
          <div class="endpoint-form" v-for="(endpoint, index) in uploadendpoint" :key="index">
            <label for="uploadendpoint">endpoint name</label><div class="check">*</div>
            <input id="uploadendpoint" type="text" v-model="endpoint.name" />
            <label for="uploadmethod">Method</label><div class="check">*</div><br />
            <select id="uploadmethod" type="text" v-model="endpoint.method">
              <option value="GET">GET</option>
              <option value="POST">POST</option>
              <option value="PUT">PUT</option>
              <option value="DELETE">DELETE</option>
            </select><br />
            <label for="uploadendpointURL">endpoint URL</label><div class="check">*</div>
            <input id="uploadendpointURL" type="text" v-model="endpoint.path" />
            <label for="uploadendpointdiscription">APIの仕様説明</label><div class="check">*</div><br />
            <textarea id="uploadendpointdiscription" row="5" cols="40" v-model="endpoint.description" style="height: 5lh;"></textarea><br />
            <!-- ボタン -->
            <div class="pmbuttons">
              <button
              type="button"
              @click="removeEndpoint(index)"
              :disabled="uploadendpoint.length === 1"
              >−</button>

              <button
              type="button"
              v-if="index === uploadendpoint.length - 1"
              @click="addEndpoint"
              >＋</button>
            </div>
          </div>
          <button type="submit">Upload to DB</button>
          <h3>
            <div v-if="uploadResult !== null">
              Upload Result :<br />
              {{ uploadResult }}
            </div>
          </h3>
        </section>
      </div>
    </div>

    <div v-else>
      <section>
        <h2>ログインが必要です。</h2>
      </section>
    </div>
  </form>
</template>

<script setup>
import { ref, onUnmounted } from "vue";
import { useUserStore } from "../store/user.js";

const userStore = useUserStore();
const uploadedJSON = ref([]);
const uploadTitle = ref("");
const uploadExplain = ref("");
const uploadCategory = ref("");
const uploadFileGenre = ref("");
const uploadSystemURL = ref("");
const uploadManualURL = ref("");
const uploadmanager = ref("");
const uploadlicense = ref("");
const uploaddescription = ref("");
//API用仮置き
const uploadAPIURL = ref("");
const uploadendpoint = ref([
  {
    _id: 1,
    name: '',
    method: '',
    path: '',
    description: '',
  }
]);
const nextEndpointId = ref(2);
//ここまで仮置き
const username = ref(userStore.username);
const uploadResult = ref(null);
const LoggedIn = ref(userStore.userLogged);
const fileError = ref(null);

const addEndpoint = () => {
  uploadendpoint.value.push({
    _id: nextEndpointId.value,
    name: '',
    method: '',
    path: '',
    description: ''
  })
  nextEndpointId.value++;
}

const removeEndpoint = (index) => {
  uploadendpoint.value.splice(index, 1)
}

async function loadLog(event) {
  const files = event.target.files || event.dataTransfer.files;
  const file = files[0];

  if (!checkFile(file)) {
    alert("ファイル読み込みに問題があります。");
    return;
  }
  try {
    const logData = await getFileData(file);
    const logJson = JSON.parse(logData);
    console.log(logJson);
    uploadedJSON.value = logJson;
  } catch (error) {
    alert("JSONファイルに問題があります。" + error.message);
    uploadResult.value = "Result Fail";
  }
}
function getFileData(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsText(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

function checkFile(file) {
  if (!file) {
    return false;
  }

  if (file.type !== "application/json") {
    return false;
  }

  const SIZE_LIMIT = 5000000; // 5MB
  if (file.size > SIZE_LIMIT) {
    return false;
  }
  return true;
}

function submitForm() {

  if (!isFormValid()) {
    alert("入力内容に問題があります。");
    return;
  }
  upload();
}

function isFormValid() {
  // 各フォームの内容をチェックし、問題があれば false を返す
  if (uploadTitle.value.trim() === "") {
    return false;
  }
  if (uploadExplain.value.trim() === "") {
    return false;
  }
  if (uploadCategory.value === "") {
    return false;
  }
  if (uploadmanager.value.trim() === "") {
    uploadmanager.value = "未設定";
  }
  if (uploadCategory.value === "システム") {
    if (uploadSystemURL.value.trim() === "") {
      return false;
    }
  } else if (uploadCategory.value === "オープンデータ") {
    if (uploadFileGenre.value === "") {
      return false;
    }
    if (uploadedJSON.value.length === 0) {
      return false;
    }
    if (uploadlicense.value.trim() === "") {
      return false;
    }
  } else if (uploadCategory.value === "API") {
    if (uploadAPIURL.value.trim() === "") {
      return false;
    }
    if (uploadendpoint.value.length === 0) {
      return false;
    }
    for (const endpoint of uploadendpoint.value) {
      if (
        endpoint.name.trim() === "" ||
        endpoint.method.trim() === "" ||
        endpoint.path.trim() === "" ||
        endpoint.description.trim() === ""
      ) {
        return false;
      } 
      const name = endpoint.name.trim();
      for (const otherEndpoint of uploadendpoint.value) {
        if (otherEndpoint !== endpoint && otherEndpoint.name.trim() === name) {
          return false; // 重複する名前が見つかった場合
        }
      }
    }
  }
  return true;
}

async function upload() {
  // user.value = userStore.user
  if (uploadCategory.value === "システム") {
    //console.log('システム')
    //console.log(username.value,uploadTitle.value,uploadExplain.value,uploadCategory.value,uploadSystemURL.value)
    await userStore.uploadSystem(
      username.value,
      uploadTitle.value,
      uploadExplain.value,
      uploadCategory.value,
      uploadSystemURL.value,
      uploadManualURL.value,
      uploadmanager.value,
    );
  } else if (uploadCategory.value === "オープンデータ") {
    //console.log('オープンデータ')
    //console.log(username.value,uploadTitle.value,uploadExplain.value,uploadCategory.value,uploadFileGenre.value,uploadedJSON.value)
    await userStore.uploadData(
      username.value,
      uploadTitle.value,
      uploadExplain.value,
      uploadCategory.value,
      uploadFileGenre.value,
      uploadmanager.value,
      uploadlicense.value,
      uploaddescription.value,
      uploadedJSON.value
    );
  } else if (uploadCategory.value === "API") {
    //仮置き
    console.log('仮置き');
    await userStore.uploadAPI(
      username.value,
      uploadTitle.value,
      uploadExplain.value,
      uploadmanager.value,
      uploadCategory.value,
      uploadAPIURL.value,
      uploadendpoint.value
    );
  }

  uploadResult.value = userStore.uploadRes;
}

onUnmounted(() => {
  uploadResult.value = userStore.uploadRes;
});

async function handleFileUpload(event) {
  const file = event.target.files[0];
  if (!file) {
    fileError.value = "ファイルが選択されていません";
    return;
  }
  if (file.type !== "application/pdf") {
    fileError.value = "選択されたファイルがPDF形式ではありません";
    return;
  }

  if (file) {
    const url = URL.createObjectURL(file);
    // uploadManualURLの値を更新する
    uploadManualURL.value = url;
  }
}
</script>

<style>
section {
  margin-left: 350px;
}

.endpoint-form {
  margin-top: 1em;
  margin-bottom: 1em;
  padding: 1em;
  border: solid 1px #000000;
  border-radius: 8px;
}

.pmbuttons {
  text-align: right;
}
.pmbuttons button {
  background-color: aquamarine;
  border: none;
}

.my-radio {
  position: relative;
  display: block;
  /* 縦並びに */
  margin: 0.5em 0;
  /* 前後のスペース */
  padding-left: 28px;
  cursor: pointer;
  user-select: none;
}
.check {
  font-size: 14px;
  text-decoration: none;
  color: red;
  display: inline;
  margin-left: 5px;
}

/* inputは非表示にする */
.my-radio input {
  display: none;
}

/* 常に表示する枠線の円 */
.radio-mark {
  position: absolute;
  top: 0;
  /* 上からの位置 */
  left: 0;
  height: 22px;
  /* 大きさ */
  width: 22px;
  /* 大きさ */
  border: solid 2px #d4dae2;
  /* 線 */
  border-radius: 50%;
  box-sizing: border-box;
}

/* 選択時に重ねる円 */
.radio-mark:after {
  content: "";
  position: absolute;
  background: #2e80ff;
  /* 色 */
  border-radius: 50%;
  top: 2px;
  bottom: 2px;
  left: 2px;
  right: 2px;
  opacity: 0;
  /* 透明にしておく */
}

/* 選択時に重ねた円の透明を解除 */
.my-radio input:checked + .radio-mark:after {
  opacity: 1;
}
</style>
